
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.883 5.531v11.916C.883 18.857 2.068 20 3.529 20h7.941c1.462 0 2.648-1.143 2.648-2.553V5.53H.883zm3.532 11.786c0 .31-.198.56-.443.56H3.53c-.244 0-.442-.25-.442-.56V7.788c0-.298.185-.537.417-.554h.493c.232.017.417.256.417.554v9.529h.001zm3.97 0c0 .31-.198.56-.442.56h-.886c-.244 0-.442-.25-.442-.56V7.788c0-.298.185-.537.417-.554h.935c.232.017.418.256.418.554v9.529zm3.528-9.529v9.529c0 .31-.198.56-.443.56h-.443c-.244 0-.442-.25-.442-.56V7.788c0-.298.186-.537.418-.554h.492c.233.017.418.256.418.554zm2.205-5.66H.883c-.488 0-.883.38-.883.85v.426c0 .47.395.851.883.851h13.235c.487 0 .882-.38.882-.851v-.426c0-.47-.395-.85-.882-.85zM6.46 0h2.238c.488 0 .882.381.882.851v.425c0 .47-.395.851-.882.851H6.459c-.487 0-.882-.38-.882-.85V.85c0-.47.395-.851.882-.851z","fill":"red"}})])
          )
        }
      }
    